import React from 'react';

import {
    FormItem,
    ModalPageHeader,
    PanelHeaderButton,
    ModalRoot,
    ModalPage,
    SplitLayout,
    SplitCol,
    List,
    RichCell,
    Search,
    Cell,
    Spinner,
    Button, Div
} from '@vkontakte/vkui';

import * as constants from "./constants";
import {
    Icon20AddCircleFillGreen,
    Icon24BrowserBack,
    Icon24Dropdown,
    Icon24Search
} from "@vkontakte/icons";
import {
    AdaptivityContext, getGUID, last_store_klients_items_key,

    store_klients_items_key
} from "./constants";
import BaseApi from "../api/BaseApi";
import BaseComponent from "../components/BaseComponent";

class SelectObject extends BaseComponent {

    /**
     * Revert 1C transport placeholders and normalize ¶ / CR/LF to spaces.
     * Order matters: -bslh- before -slh-.
     */
    decode1cPlaceholders = (str) => {
        if (!str || typeof str !== 'string') {
            return str
        }
        return str
            .replace(/-lqt-/gi, '«')
            .replace(/-rqt-/gi, '»')
            .replace(/-bslh-/gi, '/')
            .replace(/-slh-/gi, '\\')
            .replace(/-amp-/gi, '&')
            .replace(/[\u00b6\r\n]+/g, ' ')
            .replace(/ {2,}/g, ' ')
            .trim()
    }

    formatAddressItem = (el) => {
        if (!el || el.Код == undefined) {
            return el
        }
        const value = this.decode1cPlaceholders(el.Значение)
        return {
            ...el,
            name: value,
            Значение: value,
            external_id: el.Код,
            id: el.Код,
            descr: el.Тип,
        }
    }

    receiveMessage = (event) => {
        if (event.data == 'openSelectObject' + (this.props.objectId ? this.props.objectId : '')) {

        }
        if (event.data == "closeSelectObject" + this.guid) {
            this.setActiveModal(null)
        }
        if (event.data == "resetDefaultSelected") {
            this.setState({default_selected: false})
        }

        if (event.data.type != undefined) {
            if (event.data.type == 'setSearchSelectObject' + (this.props.objectId ? this.props.objectId : '')) {
                this.setState({search: event.data.value, showSearch: true})
                this.setState({showSearch: true})
                setTimeout(() => this.getItems(event.data.value))
            }
            if (event.data.type == "addKlientToList") {

                let oldStoreKlients = localStorage.getItem(store_klients_items_key)
                if (!oldStoreKlients) {
                    oldStoreKlients = {}
                } else {
                    oldStoreKlients = JSON.parse(oldStoreKlients)
                }

                const new_item = {
                    ...event.data.value,
                    meta: '{}',
                    id: event.data.value.external_id,
                    title: event.data.value.last_name + ' ' + event.data.value.first_name + ' ' + event.data.value.sur_name + ' ' + event.data.value.phone
                }
                oldStoreKlients[new_item.external_id] = new_item
                localStorage.setItem(store_klients_items_key, JSON.stringify(oldStoreKlients))
                localStorage.setItem(last_store_klients_items_key, new_item.external_id)
                this.getItems()
                setTimeout(() => {
                    this.state.items.map((el, index) => {
                        if (el.external_id == new_item.external_id) {
                            this.selectObject(index)
                        }
                    })

                }, 700)
            }
        }
    }
    checkScrollInterval = null

    componentDidMount() {

        super.componentDidMount()
        this.checkScrollInterval = setInterval(() => this.checkScroll(), 1000)
        if (this.props.default != undefined && !this.state.default_selected) {
            let el = this.props.default;

            if (el.Код != undefined) {
                this.setState({current_object: this.formatAddressItem(el)})
            } else {
                if (el.id && el.INN) {
                    el.descr = el.INN ?? el.descr
                }
                this.setState({current_object: el})

            }

            this.setState({default_selected: true})
        }
        if (this.props.items != undefined && this.props.items.length > 0 && this.props.auto_open && !this.state.default_opened && !this.props.no_address) {
            this.setState({default_opened: true})
            this.showList()
        }

    }

    componentWillUnmount() {
        super.componentWillUnmount()
        if (this.checkScrollInterval) {
            clearInterval(this.checkScrollInterval)
        }
    }

    componentWillReceiveProps(nextProps) {

        //    console.log(nextProps, this.state.default_selected)
        if (nextProps.default != undefined && !this.state.default_selected) {
            let el = nextProps.default;
            //  console.log(nextProps)
            if (el.Код != undefined) {
                const item = this.formatAddressItem(el)
                this.setState({current_object: item})
                this.props.selectObject(item)
            } else {
                if (el.id && el.INN) {
                    el.descr = el.INN ?? el.descr
                }
                this.setState({current_object: el})

            }
            this.setState({default_selected: true})
        }
        if (nextProps.items != undefined && nextProps.items.length > 0 && nextProps.auto_open && !this.state.default_opened && !this.props.no_address) {
            this.setState({default_opened: true})
            setTimeout(() => {
                this.showList()
            }, 500)
        }
    }

    checkScroll = () => {


        if (!this.ref.current) return
        if (this.state.cnt_items * 1 <= this.state.items.length) return
        let visible = this.ref.current.getBoundingClientRect().top < window.innerHeight - 50;

        if (!this.state.loading && visible) {
            let page = this.state.page
            if (page >= this.state.totalPages * 1) return
            page++;
            this.setState({page: page})

            this.getItems('', true, page)


        }
    }

    getItems = (search_ = '', append = false, page = 1) => {
        if (this.props.items != undefined) {
            let items = [];
            this.props.items.map((el, i) => {
                if (!el.Значение) return
                items.push(this.formatAddressItem(el))
            })

            if (items.length == 0) {
                this.props.items.map((el, i) => {
                    if (!el.title) return
                    items.push({name: el.title, external_id: el.id, id: el.id, descr: el.descr})
                })

            }

            const search = search_ ? search_ : this.state.search
            let filteredItems = items
            if (search) {
                const searchValue = search.toLowerCase()
                filteredItems = items.filter((item) => {
                    const name = (item.name || '').toLowerCase()
                    const descr = (item.descr || '').toLowerCase()
                    return name.includes(searchValue) || descr.includes(searchValue)
                })
            }

            this.setState({
                loading: false,
                items: filteredItems,
                cnt_items: filteredItems.length,
                totalPages: 1
            });
        } else {
            const search = search_ ? search_ : this.state.search
            append = append == undefined ? false : append
            if (page == undefined) {
                page = this.state.page;
            }
            
            // Специальная обработка для подразделений - используем getDivisions
            if (this.props.app === 'divisions' && this.props.act === 'getListJson') {
                this.setState({loading: true})
                console.log(`🔍 SelectObject.getItems: используем getDivisions для поиска "${search}"`);
                
                BaseApi.getDivisions((divisions) => {
                    this.setState({loading: false})
                    const items = append ? this.state.items : []
                    const results = divisions || []
                    
                    results.map((el, i) => {
                        el.name = el.title || el.name
                        el.uid = el.id
                        el.id = el.external_id || el.id
                        el.descr = el.descr ?? el.INN
                        items.push(el)
                    })

                    this.setState({items: items});
                    this.setState({cnt_items: results.length})
                    this.setState({totalPages: 1})
                }, search, false);
                return;
            }
            
            let sAjaxSource = '/?app=' + this.props.app + '&act=' + this.props.act
            if (this.props.params) {
                sAjaxSource = sAjaxSource + '&' + this.props.params
            }
            this.setState({loading: true})
            
            console.log(`🔍 SelectObject.getItems: запрос к ${sAjaxSource} с поиском "${search}", страница ${page}`);

            BaseApi.post(sAjaxSource, {search, page, epp: AdaptivityContext.isMobile ? 10 : 20},).then((response) => {
                console.log(`✅ SelectObject.getItems: получен ответ для "${search}", результатов: ${response.data.results?.length || 0}`);
                this.setState({loading: false})
                const items = append ? this.state.items : []
                let results = response.data.results
                let oldStoreKlients = localStorage.getItem(store_klients_items_key)
                if (!oldStoreKlients) {
                    oldStoreKlients = {}
                } else {
                    oldStoreKlients = JSON.parse(oldStoreKlients)
                }
                Object.keys(oldStoreKlients).map((key) => {
                    results.push(oldStoreKlients[key])
                })
                results.map((el, i) => {
                    el.name = el.title
                    el.uid = el.id
                    el.id = el.external_id
                    el.descr = el.descr ?? el.INN
                    items.push(el)
                })

                this.setState({items: items});
                this.setState({cnt_items: response.data.iTotalRecords})
                this.setState({totalPages: response.data.iTotalPages})
            }).catch((error) => {
                console.error('❌ Ошибка при загрузке данных в SelectObject:', error);
                this.setState({loading: false, items: append ? this.state.items : []});
            })
        }

    };

    showList = () => {
        this.setActiveModal(constants.MODAL_LIST_OBJECTS)
        this.getItems()
    }

    selectObject = (index) => {

        this.setState({current_object: this.state.items[index]})
        if (this.props.selectObject != undefined) {
            this.props.selectObject(this.state.items[index])
        }

        if (this.props.clear_after_select) {
            this.setState({current_object: {}})
        }

        this.modalBack()
    }
    toggleSearch = () => {


        this.setState({showSearch: !this.state.showSearch});

    }

    searchInterval = null

    onSearchChange = (state) => {


        clearInterval(this.searchInterval);
        this.setState({search: state.target.value});
        this.searchInterval = setInterval(() => {
            clearInterval(this.searchInterval)
            this.setState({loading: true, page: 1})
            this.getItems(this.state.search, false, 1)
        }, state.target.value == '' ? 500 : 1000)

    }

    renderRow = (item, index, last_store_klients_id = null) => {
        //console.log(item)
        const {current_object} = this.state

        return <RichCell key={'select_obj' + index} onClick={() => this.selectObject(index)} multiline
                         style={{border: item.external_id && item.external_id == last_store_klients_id ? '1px solid orange' : 'inherit'}}
                         className={current_object && current_object.external_id
                         && item.external_id && item.external_id == current_object.external_id ? 'selectObject_selected-row' : ''}
                         subhead={item.descr}
        >
            {item.name}
        </RichCell>
    }

    renderButton = (styleDefault) => {
        return <div style={{display: 'flex'}}><Button size={this.props.size ? this.props.size : "l"}
                                                      disabled={this.props.disabled ?? false}
                                                      mode={this.props.mode ? this.props.mode : "primary"}
                                                      className={this.props.className}
                                                      after={<Icon24Dropdown/>}
                                                      style={{...styleDefault, ...this.props.style}}
                                                      onClick={() => this.showList()}
                                                      before={this.props.icon ? this.props.icon : ''}
                                                      selected={this.state.current_object.id != undefined}
                                                      expandable

        >
            {this.state.current_object.id != undefined || this.state.current_object.uid != undefined ? (this.state.current_object.title ?? this.state.current_object.name) : (this.props.unselect_title ? this.props.unselect_title : 'Не указан')}
        </Button>
            {this.props.addon ?? ''}
        </div>
    }

    renderCreateForm() {

    }

    createAction() {

    }

    constructor(props) {
        super(props);
        const state = {
            loading: false,
            items: [],
            current_object: {},
            search: '',
            page: 1,
            cnt_items: 0,
            append: false,
            totalPages: 1,
            showSearch: false,
            default_selected: false,
            default_opened: false, ...this.state
        }

        this.state = {
            ...this.state,
            ...state
        }
        this.guid = getGUID()

    }

    closeList = () => {
        this.setState({search: '', page: 1, items: []})
        this.modalBack()
        setTimeout(() => this.getItems(), 600)
    }

    render() {

        const last_store_klients_id = localStorage.getItem(last_store_klients_items_key)

        const empty_rows_message = this.props.empty_rows_message ?? 'Ничего не найдено'

        const modals = (<ModalRoot activeModal={this.state.activeModal}>
            <ModalPage
                id={constants.MODAL_SELECT_LIST_ADD}
                onClose={() => this.closeList()}
                settlingHeight={100}
                style={{zIndex: 9999999999999}}
                header={
                    <ModalPageHeader className="sclads"
                                     before={<PanelHeaderButton
                                         onClick={() => this.closeList()}><Icon24BrowserBack/></PanelHeaderButton>}

                    >
                        {this.props.modal_title ? this.props.modal_title : this.props.title}
                    </ModalPageHeader>
                }
            >
                <Div style={{paddingBottom: '150px'}}>
                    {this.renderCreateForm()}
                </Div>
            </ModalPage>
            <ModalPage
                id={constants.MODAL_LIST_OBJECTS}
                onClose={this.modalBack}
                settlingHeight={100}

                header={<ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}
                                         after={
                                             <div style={{display: 'flex'}}>
                                                 {this.props.create_action && AdaptivityContext.isMobile && <PanelHeaderButton
                                                     onClick={() => {
                                                         this.createAction()
                                                         this.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
                                                     }}>
                                                     <Icon20AddCircleFillGreen/>
                                                 </PanelHeaderButton>}
                                                 <PanelHeaderButton
                                                     onClick={() => this.props.searchAct && this.props.current_user && this.props.current_user.meta.settings.search_klients_by_phone == '1' ? this.props.searchAct() : this.toggleSearch()}>
                                                     <Icon24Search/>
                                                 </PanelHeaderButton>
                                             </div>

                                         }
                >
                    {this.props.modal_title ? this.props.modal_title : this.props.title}
                </ModalPageHeader>}
            >
                <form
                    onSubmit={e => {
                        e.preventDefault();
                        e.stopPropagation()
                    }} className="mobile-table-storage-header" key={'select_obj_panel'}
                    style={{display: 'flex', alignItems: 'center', top: '0px'}}>

                    <Search autoFocus

                            theme="header"
                            placeholder="Поиск"
                            value={this.state.search}
                            onChange={this.onSearchChange}
                            onIconClick={this.toggleSearch}
                            onReset={this.toggleSearch}
                            style={{flexGrow: '1', maxWidth: '340px'}}
                    />

                    {this.props.create_action && !AdaptivityContext.isMobile &&
                        <Button mode="outline" size="s" style={{height: '35px'}}
                                onClick={() => {
                                    this.createAction()
                                    this.setActiveModal(constants.MODAL_SELECT_LIST_ADD)
                                }}><Icon20AddCircleFillGreen/></Button>
                    }
                </form>
                <List className="selectObject-list">

                    {this.state.items && this.state.items.map((item, index) => (this.renderRow(item, index, last_store_klients_id)))}
                    {AdaptivityContext.isMobile || true ?
                        <div ref={this.ref} key={"loaderSelectList" + getGUID()}
                             style={{height: '50px', width: 'auto'}}>{this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}</div> : this.state.loading ?
                            <Cell before="Запрашиваем данные с сервера"
                                  after={<Spinner size="large"/>}></Cell> : ""}
                    {this.state.items.length > 0 || this.state.loading ? '' :
                        <RichCell key={'sel_obj0'} className="empty_rows_message"

                        >
                            {empty_rows_message}
                        </RichCell>}
                </List>
            </ModalPage>
        </ModalRoot>)

        const styleDefault = {
            width: '100%', height: 'auto', minHeight: '44px', overflow: 'show', whiteSpace: 'break-spaces'
        }
        const btn = this.renderButton(styleDefault)


        return (this.props.only_btn ? <SplitLayout modal={modals} key={`select-object-${this.guid}`}>
                <SplitCol width="100%">
                    {btn}
                </SplitCol>
            </SplitLayout> : <SplitLayout modal={modals} key={`select-object-${this.guid}`}>
                <SplitCol width="100%">
                    <FormItem
                        top={`${this.props.title}`}
                        bottom={this.props.error}
                        status={this.props.error ? 'error' : 'valid'}>

                        {btn}

                    </FormItem>
                </SplitCol>
            </SplitLayout>

        );
    }


}

export default SelectObject;
